module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-text-component",
    class: _vm.inline ? 'inline-input' : ''
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "my-input"
    }
  }, [(_vm.asterisk) ? _c('span', {
    staticClass: "glyphicon glyphicon-asterisk text-danger"
  }) : _vm._e(), _vm._v(_vm._s(_vm.label))]) : _vm._e(), (_vm.useState || _vm.callback) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    ref: "input",
    class: _vm.computedClasses,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.localValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.localValue = $event.target.value
      }, _vm.value]
    }
  }) : _c('input', {
    ref: "input",
    class: _vm.computedClasses,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47968d38"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InputText.vue
// module id = 358
// module chunks = 2